import type {Dayjs} from 'dayjs';
import type {Point} from 'geojson';

export enum STATUS {
  FOREST_MASS_CREATED = 'FOREST_MASS_CREATED',
  CUT_FORCED = 'CUT_FORCED',
  PENDING_PLOT_INVENTORIES = 'PENDING_PLOT_INVENTORIES',
  PENDING_UAV_FLIGHT = 'PENDING_UAV_FLIGHT',
  PENDING_PLOT_INVENTORY_APPRAISER = 'PENDING_PLOT_INVENTORY_APPRAISER',
  CUT_PENDING = 'CUT_PENDING',
  WEIGHT_PENDING = 'WEIGHT_PENDING',
  CUT_WEIGHTED = 'CUT_WEIGHTED',
  PENDING_INVENTORY_PLOTS = 'PENDING_INVENTORY_PLOTS',
  PENDING_SLAM = 'PENDING_SLAM',
  INVENTORY_PLOTS_COMPLETED = 'INVENTORY_PLOTS_COMPLETED',
  UAV_FLIGHT_DONE = 'UAV_FLIGHT_DONE',
  METRICS_PROCESSING = 'METRICS_PROCESSING',
  METRICS_SUCCESSFUL = 'METRICS_SUCCESSFUL',
  METRICS_FAILED = 'METRICS_FAILED',
}

export type ForestMassStatus = {
  forestMassUuid: string;
  code: string;
  concello: string;
  appraiserName: string | null;
  plannedCuttingDate: Dayjs;
  position: Point;
  createdAt: Dayjs;
  finsaStatus: STATUS;
  finsaStatusChangeDate: Dayjs;
  aseforStatus: STATUS;
  aseforStatusChangeDate: Dayjs;
  fortopStatus: STATUS;
  fortopStatusChangeDate: Dayjs;
  uavMetricsStatus: STATUS | null;
  uavMetricsStatusChangeDate: Dayjs | null;
};
